import React from 'react';
import CasinoContainer from '../../../../../components/casino/CasinoContainer';
import ProvidersSettingContent from './ProvidersSettingContent';

export default function PaymentProviders() {
  return (
    <CasinoContainer title={'Payment providers settings'}>
      <ProvidersSettingContent />
    </CasinoContainer>
  );
}
